module.exports = "/_next/static/media/9e23354e9f3ba6d79ce9110ec6ab6f07.svg";